import type { PeLtelYear } from '../../types';

export interface LtelBarRow {
  schoolYear: string;
  count: number;
  newlyEntered: number | null;
  continuing: number;
}

export function buildLtelCountBarData(years: PeLtelYear[]): LtelBarRow[] {
  return [...years]
    .sort((a, b) => a.school_year.localeCompare(b.school_year))
    .map((year) => {
      if (year.newly_entered == null) {
        return {
          schoolYear: year.school_year,
          count: year.count,
          newlyEntered: null,
          continuing: year.count,
        };
      }
      const newlyEntered = Math.min(Math.max(year.newly_entered, 0), year.count);
      return {
        schoolYear: year.school_year,
        count: year.count,
        newlyEntered,
        continuing: Math.max(year.count - newlyEntered, 0),
      };
    });
}
